import { MIME_TYPE } from '@/constants/common'
import URLify from '@/utils/URLify'
import updateEditorHTML from '@/utils/updateEditorHTML'

/**
 * It formats free-text based on its MIME_TYPE
 * @param text
 * @param type
 * @param orgId
 * @returns string
 */
export default (orgId, text, type = MIME_TYPE.HTML) => {
  let formatted = text
  if (type === MIME_TYPE.TEXT) {
    formatted = URLify(text)
  } else if (type === MIME_TYPE.HTML) {
    formatted = updateEditorHTML(text, orgId)
  }
  return formatted
}
